// TODO: Fix all linting warnings in layout-lib #36010
/* eslint-disable */
import {
  Compiler,
  Inject,
  InjectionToken,
  Injector,
  ModuleWithProviders,
  NgModule,
  NgModuleFactory,
  NgModuleRef,
  Optional,
  Provider,
  SkipSelf,
} from '@angular/core';
import { Router } from '@angular/router';

import { Menu, Menus } from './menu.model';
import { MenuService } from './menu.service';

export const MENU_FORROOT_GUARD = new InjectionToken<void>('MENU_FORROOT_GUARD');
export const MENU_INJECTOR = new InjectionToken<void>('MENU_INJECTOR');
export const MENUS = new InjectionToken<Menu[][]>('MENUS');

export const MENU_PROVIDERS: Provider[] = [
  {
    provide: MenuService,
    useFactory: setupMenuService,
    deps: [MENUS, Router],
  },
];

export const PROVIDER_FOR_MENU_GUARD: Provider[] = [
  {
    provide: MENU_FORROOT_GUARD,
    useFactory: provideForRootGuard,
    deps: [[MenuService, new Optional(), new SkipSelf()]],
  },
];

export const MENU_PROVIDER_INJECTOR: Provider[] = [
  {
    provide: MENU_INJECTOR,
    useFactory: injectMenus,
    deps: [Compiler, [new SkipSelf(), Injector], Injector, MenuService],
  },
];

@NgModule({})
export class MenuModule {
  constructor(
    @Optional() @Inject(MENU_FORROOT_GUARD) guard: any,
    @Optional() _menuService: MenuService,
    @Optional() _router: Router,
    @Inject(MENU_INJECTOR) _inject: any
  ) {}

  static forRoot(menus?: Menus): ModuleWithProviders<MenuModule> {
    var module = {
      ngModule: MenuModule,
      providers: [MENU_PROVIDERS, MENU_PROVIDER_INJECTOR, PROVIDER_FOR_MENU_GUARD],
    };

    if (menus !== undefined) {
      module.providers.push(provideMenus(menus));
    }

    return module;
  }

  /**
   * Creates a module with all the router directives and a provider registering routes.
   */
  static forChild(menus: Menus): ModuleWithProviders<MenuModule> {
    // Insert menus into menu service
    return {
      ngModule: MenuModule,
      providers: [provideMenus(menus), MENU_PROVIDER_INJECTOR],
    };
  }
}

export function provideForRootGuard(menuService: MenuService): any {
  if (menuService) {
    throw new Error(`MenuModule.forRoot() called twice. Lazy loaded modules should use MenuModule.forChild() instead.`);
  }

  return 'guarded';
}

export function provideMenus(menus: Menus): any {
  return [{ provide: MENUS, multi: true, useValue: menus }];
}

export function injectMenus(
  compiler: Compiler,
  parentInjector: Injector,
  injector: Injector,
  menuService: MenuService
): any {
  if (!menuService) {
    throw new Error(
      `MenuModule.forRoot() not called. Lazy loaded modules should be only called after MenuModule.forRoot().`
    );
  }
  const menus = flatten(injector.get(MENUS, null));
  const parentMenus = flatten(parentInjector.get(MENUS, null));
  const module = injector.get(NgModuleRef);
  const filteredParents = parentMenus.filter((item) => !item.children && item.loadChildren);
  for (const parentMenu of filteredParents) {
    areParentMenusChildren(compiler, parentMenu, module.instance).then((flag) => {
      if (flag) {
        menuService.setChildren(menuService.getMenuIdentifier(parentMenu), menus);
      }
    });
  }

  return 'injected';
}

export function setupMenuService(config: Menu[][], router: Router) {
  return new MenuService(flatten(config), router);
}

/**
 * Flattens single-level nested arrays.
 */
export function flatten<T>(arr: T[][]): T[] {
  return Array.prototype.concat.apply([], arr);
}

async function areParentMenusChildren(compiler: Compiler, menu: Menu, instance: any): Promise<boolean> {
  const moduleFactory = await loadModuleFactory(compiler, menu.loadChildren);
  const moduleType = moduleFactory.moduleType;
  return instance instanceof moduleType;
}

export async function loadModuleFactory(compiler: Compiler, t: any) {
  if (t instanceof NgModuleFactory) {
    return t;
  } else {
    return await compiler.compileModuleAsync(t);
  }
}
